export default __webpack_public_path__ + "static/media/service01.c761c5cf.png";